module.exports = __webpack_public_path__ + "static/media/Item_Weapon_Machete_C.37b051d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Weapon/Melee/Item_Weapon_Machete_C.png
// module id = 252
// module chunks = 0